






































import { computed, defineComponent, ref } from "@vue/composition-api";
import { VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { isMediaFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import config from "@/config";
import { AttachmentFile } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import VaultController from "@/components/VaultController";
import { FilterSubject } from "@/components/VaultController/types";

export default defineComponent({
  name: "VaultModal",
  components: { BaseInputFileWithPreview, BaseButton, BaseIconButton, BaseConfirm, VaultController },
  props: {
    show: { type: Boolean, default: false },
    maxFiles: { type: Number, default: Number.POSITIVE_INFINITY },
    recipient: { type: Object as () => UserPublicData },
    filterSubject: { type: Object as () => FilterSubject },
    accept: { type: Array as () => string[], default: () => ["image", "video", "audio", "document"] },
  },
  setup(props, { emit }) {
    const hasSelection = ref<boolean>(false);

    const { authUserStrict } = useAuthUser();
    const isMember = computed(() => authUserStrict.value && authUserStrict.value.role === config.userRegistrationRole);

    const addAttachment = async (files: File[]) => {
      emit("addAttachment", files);
      emit("close");
    };

    const addAttachmentFromVault = (files: VaultFile[]) => {
      const attachmentFiles: AttachmentFile[] = files.map(file => ({
        src: !isMediaFile(file)
          ? MediaFilesController.getFileUrl(file.urlPart)
          : getMediaThumbnailUrl(file, file.urlPart),
        uid: file.uuid,
        type: file.metadata.contentType,
        publicAccess: false,
        metadata: file.metadata
      }));
      emit("addAttachmentFromVault", attachmentFiles);
      emit("close");
    };

    return { addAttachment, addAttachmentFromVault, isMember, hasSelection };
  },
});
